// Bilingual (DE/EN) content for the research-software portfolio.

export const products = [
  {
    id: "sociallecture",
    name: "SocialLecture.at",
    url: "https://cardstack-hub.emergent.host/",
    image:
      "https://customer-assets-v7afamib.emergentagent.net/job_multi-lang-products/artifacts/3ojysz40_Titelbild_web_Sociallecture.jpg",
    category: { DE: "Lernplattform", EN: "Learning Platform" },
    title: {
      DE: "SocialLecture",
      EN: "SocialLecture",
    },
    description: {
      DE: "Lernplattform mit Lernkarten für Sozialpädagogik und Soziale Arbeit. Aufbereitet werden Prinzipien, Modelle, Methoden und weitere wissenschaftliche Zugänge.",
      EN: "A learning platform with flashcards for social pedagogy and social work. It presents principles, models, methods and further scholarly approaches.",
    },
  },
  {
    id: "sozialeforschung",
    name: "sozialeforschung.at",
    url: "https://scholarlyworks.emergent.host/",
    image:
      "https://customer-assets-v7afamib.emergentagent.net/job_multi-lang-products/artifacts/a92akq8z_sozialeforachung.at.png",
    category: { DE: "Plattform", EN: "Platform" },
    title: {
      DE: "Sozialpädagogische Forschung",
      EN: "Social Pedagogy Research",
    },
    description: {
      DE: "Eine offene Plattform für sozialpädagogische Publikationen, Abschlussarbeiten und weiterführende Verweise. Wissen sichtbar, auffindbar und teilbar machen.",
      EN: "An open platform for social pedagogy publications, theses and further references. Making knowledge visible, findable and shareable.",
    },
  },
  {
    id: "kutea",
    name: "kutea.at",
    url: "https://content-coder-1.emergent.host/",
    image:
      "https://customer-assets-v7afamib.emergentagent.net/job_multi-lang-products/artifacts/2qkeo6uz_kutea.png",
    category: { DE: "Analyse", EN: "Analysis" },
    title: {
      DE: "Qualitative Textanalyse",
      EN: "Qualitative Text Analysis",
    },
    description: {
      DE: "Werkzeug zur systematischen Kodierung und Interpretation qualitativer Daten. Strukturiert Interviews, Dokumente und Feldnotizen zu belastbaren Erkenntnissen.",
      EN: "A tool for the systematic coding and interpretation of qualitative data. Structures interviews, documents and field notes into robust findings.",
    },
  },
  {
    id: "wordriver",
    name: "wordriver.at",
    url: "https://audio-capture-pro-2.emergent.host/",
    image:
      "https://customer-assets-v7afamib.emergentagent.net/job_multi-lang-products/artifacts/w3o9tcs6_wordriver.png",
    category: { DE: "Sprache", EN: "Speech" },
    title: {
      DE: "Speech-to-Text",
      EN: "Speech-to-Text",
    },
    description: {
      DE: "Gesprochene Sprache präzise in Text überführen. Ein schneller Weg von der Aufnahme zum bearbeitbaren Wort.",
      EN: "Turn spoken language precisely into text. A fast path from recording to the editable word.",
    },
  },
  {
    id: "textcrane",
    name: "TextCrane.at",
    url: "https://language-stats-1.emergent.host",
    image:
      "https://customer-assets-v7afamib.emergentagent.net/job_multi-lang-products/artifacts/35k4zsfs_TextCrane.jpg",
    category: { DE: "Textstatistik", EN: "Text Statistics" },
    title: {
      DE: "Textstatistik",
      EN: "Text Statistics",
    },
    description: {
      DE: "Detaillierte statistische Analyse von Texten: nennt unbekannte Wörter, zählt Zeichen, Wörter, Sätze und Absätze, berechnet durchschnittliche Wörter pro Satz und Zeichen pro Wort, Anzahl der Punktuationen, seltene Wörter sowie die Häufigkeit aller Wörter.",
      EN: "Detailed statistical analysis of texts: lists unknown words, counts characters, words, sentences and paragraphs, computes average words per sentence and characters per word, punctuation counts, rare words and the frequency of all words.",
    },
  },
  {
    id: "vortragsub",
    name: "VortragSub live",
    url: "https://caption-stream-2.emergent.host/",
    image:
      "https://customer-assets-v7afamib.emergentagent.net/job_multi-lang-products/artifacts/950b57f357b5a222_TransKript_Screen.jpg",
    category: { DE: "Live-Übersetzung", EN: "Live Translation" },
    title: {
      DE: "Live-Übersetzung bei Vorträgen",
      EN: "Live Translation for Talks",
    },
    description: {
      DE: "Präsentationssoftware für den Chrome-Browser: PDF hochladen und projizieren, Originalvortrag live übersetzen und auf die Smartphones des Publikums übertragen. Zuhörende wählen ihre Sprache aus den vorab gewählten Sprachen. Werbefrei, einmalige Abrechnung nach Minuten.",
      EN: "Presentation software for Chrome: upload and project a PDF, translate the original talk live and stream it to the audience's smartphones. Listeners pick their language from a pre-selected list. Ad-free, pay-per-minute one-off billing.",
    },
  },
  {
    id: "hafenstat",
    name: "hafenstat.at",
    url: "https://hafenstat-analytics.emergent.host/",
    image:
      "https://customer-assets-v7afamib.emergentagent.net/job_multi-lang-products/artifacts/a066a257a8cdc3a5_Logo_hafenstat.jpg",
    category: { DE: "Statistik", EN: "Statistics" },
    title: {
      DE: "Statistiksoftware",
      EN: "Statistics Software",
    },
    description: {
      DE: "Software für quantitative Auswertungen im Browser. Daten hochladen (CSV, XLS, XLSX, SAV) oder eingeben, modifizieren (u. a. Indikatoren berechnen, Rekodieren) und auswerten: deskriptive Statistik, Korrelationen, Unterschiede, Regressionen, Faktorenanalysen. Zahlreiche Grafiken (Balken-, Linien-, Flächendiagramm, Boxplot, Heatmap, Piktogramm). Kostenlos.",
      EN: "Software for quantitative analysis in the browser. Upload data (CSV, XLS, XLSX, SAV) or enter it manually, modify it (compute indicators, recode) and analyse it: descriptive statistics, correlations, group differences, regressions, factor analyses. Numerous charts (bar, line, area, boxplot, heatmap, pictogram). Free of charge.",
    },
  },
];

export const copy = {
  meta: {
    title: {
      DE: "Forschungssoftware — Software für die Sozialwissenschaften",
      EN: "Forschungssoftware — Research Software for the Social Sciences",
    },
    description: {
      DE: "Eine Sammlung von Software für qualitative und quantitative Forschung.",
      EN: "A collection of software for qualitative and quantitative research.",
    },
  },
  nav: {
    products: { DE: "Werkzeuge", EN: "Tools" },
    manifesto: { DE: "Ansatz", EN: "Approach" },
    contact: { DE: "Impressum", EN: "Imprint" },
  },
  hero: {
    kicker: { DE: "Forschungssoftware", EN: "Research Software" },
    line1: { DE: "Werkzeuge für die", EN: "Tools for" },
    line2: { DE: "sozialwissen-", EN: "social" },
    line3: { DE: "schaftliche Praxis.", EN: "science practice." },
    intro: {
      DE: "Eine Sammlung von Software für qualitative und quantitative Forschung.",
      EN: "A collection of software for qualitative and quantitative research.",
    },
    cta: { DE: "Werkzeuge ansehen", EN: "Explore the tools" },
  },
  marquee: {
    DE: "Partizipieren · Ein gutes Leben führen · Analysieren · Zitieren · Publizieren · Sich engagieren · ",
    EN: "Participate · Live a good life · Analyse · Cite · Publish · Engage · ",
  },
  manifesto: {
    heading: { DE: "Der Ansatz", EN: "The Approach" },
    chapters: [
      {
        num: "01",
        title: { DE: "Offen & zugänglich", EN: "Open & accessible" },
        text: {
          DE: "Forschung entfaltet ihren Wert, wenn Werkzeuge frei verfügbar sind. Jede Anwendung ist darauf ausgelegt, Hürden abzubauen statt aufzubauen.",
          EN: "Research unfolds its value when tools are freely available. Each application is designed to lower barriers rather than raise them.",
        },
      },
      {
        num: "02",
        title: { DE: "Methodisch fundiert", EN: "Methodologically grounded" },
        text: {
          DE: "Software folgt der Methode, nicht umgekehrt. Die Werkzeuge bilden anerkannte Verfahren der empirischen Sozialforschung nachvollziehbar ab.",
          EN: "Software follows method, not the other way around. The tools transparently reflect established procedures of empirical social research.",
        },
      },
      {
        num: "03",
        title: { DE: "Ein durchgängiger Weg", EN: "One continuous path" },
        text: {
          DE: "Von der Aufnahme über Transkription und Analyse bis zur korrekten Zitation greifen die Anwendungen ineinander — ein zusammenhängender Forschungsprozess.",
          EN: "From recording through transcription and analysis to correct citation, the applications interlock — one coherent research process.",
        },
      },
    ],
  },
  products: {
    heading: { DE: "Die Werkzeuge", EN: "The Tools" },
    subheading: {
      DE: "Sieben eigenständige Anwendungen für den Forschungsalltag.",
      EN: "Seven standalone applications for everyday research.",
    },
    visit: { DE: "Website besuchen", EN: "Visit website" },
  },
  footer: {
    heading: { DE: "Impressum", EN: "Imprint" },
    name: "Arno Heimgartner",
    org: { DE: "Universität Graz", EN: "University of Graz" },
    contactLabel: { DE: "Kontakt", EN: "Contact" },
    email: "arno.heimgartner@uni-graz.at",
    rights: {
      DE: "Forschungssoftware für die Sozialwissenschaften.",
      EN: "Research software for the social sciences.",
    },
  },
};
